// extracted by mini-css-extract-plugin
export default {"paneset":"paneset---gPu3f","nested":"nested---ZefyF","static":"static---_ihEK"};